import image1 from '../images/bfarsace_200803_4124_0016.webp'
import image2 from '../images/vpavic_210916_4760_0069.webp'
import image3 from '../images/vpavic_210916_untitled_0031.webp'
import image4 from '../images/Google_Pixel_6_Pro__Alt_Angle_.webp'
const top = [
  {
    id: '1',
    image: image1,
    name: 'Samsung Galaxy Note 20 Ultra',
    price: '1153',
    stars: '5',
    numberOfReviews: '3'
  },
  {
    id: '2',
    image: image2,
    name: 'Apple iPhone 13',
    price: '829',
    stars: '3',
    numberOfReviews: '10'
  },
  {
    id: '3',
    image: image3,
    name: 'Apple iPhone 13 Pro',
    price: '999',
    stars: '2',
    numberOfReviews: '90'
  },
  {
    id: '4',
    image: image4,
    name: 'Google Pixel 6 Pro',
    price: '899',
    stars: '4',
    numberOfReviews: '23'
  }
]
export default top
